import React, { FC, useEffect, useRef, useState } from 'react';
import TitleContentDetail from 'src/components/molecules/contentLayout/TitleContentDetail';
import { settlementDataStore } from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';
import DeductionA from '../Deduction/deductionA';
import DeductionB from '../Deduction/deductionB';
import DeductionDiv from '../Deduction/deductionDiv';
import './style.scss';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ data, type = '' }) => {
  const settlementData = settlementDataStore((state: any) => state.result).data || {};

  // view type
  const [viewType, setViewType] = useState({ view: '', fold: false });
  useEffect(() => {
    const foldType = type === '' ? false : true;
    setViewType({ view: type, fold: foldType });
  }, [type]);

  const foldClickEvent = (id: string, status: string) => {};
  const ocrEvt = () => {};
  const labelStyle = { width: '380px', color: '#777', fontSize: '13px' };
  const resultSet = data.result || {};

  const refundPaid = settlementData.total?.totRefundPaid || 0; // 환급/납부
  const determinedPaid = settlementData.total?.totDeterminedPaid || 0; // 결정세액
  const prePaid = settlementData.total?.totPrePaid || 0; // 결정세액

  const refundSet =
    refundPaid < 0 ? { status: '+', label: '납부' } : { status: '-', label: '환급' };
  const refundDiv = (
    <div className="_total_refund_div">
      <div className="_label">{refundSet.label}</div>
      <div className="_sub">{refundSet.status}</div>
      <div className="_value">{addComma(refundPaid)}</div>
    </div>
  );

  // 소득명세
  const income_detail_arr = [
    { value: resultSet.gross_salary || 0, label: '과세대상급여' },
    { value: resultSet.earned_income_ded || 0, label: '근로소득공제' },
    { value: resultSet.earned_income_amt || 0, label: '근로소득금액' },
  ];

  // 인적 공제
  const personal_deduction_arr = [
    { value: resultSet.b_ded_self || 0, label: '본인' },
    { value: resultSet.b_ded_spouse || 0, label: '배우자' },
    { value: resultSet.b_ded_dependents || 0, label: '부양가족' },
    { value: resultSet.a_ded_old || 0, label: '경로우대(70세 이상)' },
    { value: resultSet.a_ded_disabled || 0, label: '장애인' },
    { value: resultSet.a_ded_female || 0, label: '부녀자' },
    { value: resultSet.a_ded_single || 0, label: '한부모 공제' },
  ];
  const personal_deduction_sum = personal_deduction_arr.reduce((sum, item) => sum + item.value, 0);

  // 연금보험료공제
  const pension_insurance_arr = [
    { value: resultSet.ppen_national_ded || 0, label: '국민연금보험료 공제' },
    { value: resultSet.ppen_gov_ded || 0, label: '공무원연금 공제' },
    { value: resultSet.ppen_military_ded || 0, label: '군인연금 공제' },
    { value: resultSet.ppen_private_school_ded || 0, label: '사립학교교직원연금 공제' },
    { value: resultSet.ppen_postal_ded || 0, label: '별정우체국연금 공제' },
  ];
  const pension_insurance_sum = pension_insurance_arr.reduce((sum, item) => sum + item.value, 0);

  // 특별 소득공제
  const hf_rent_total = (resultSet.hf_rent_f || 0) + (resultSet.hf_rent_p || 0);
  const hf_loan_total =
    (resultSet.hf_loan_2011_u15 || 0) +
    (resultSet.hf_loan_2011_o15u30 || 0) +
    (resultSet.hf_loan_2011_o30 || 0) +
    (resultSet.hf_loan_2011_o15_fan || 0) +
    (resultSet.hf_loan_2011_o15_fon || 0) +
    (resultSet.hf_loan_2012_o15_fan || 0) +
    (resultSet.hf_loan_2012_o15_fon || 0) +
    (resultSet.hf_loan_2012_o15 || 0) +
    (resultSet.hf_loan_2012_o10u15_fon || 0);

  const special_income_arr = [
    { value: resultSet.pins_health_ded || 0, label: '건강보험료(장기요양보험료 포함)' },
    { value: resultSet.pins_emp_ded || 0, label: '고용보험료' },
    { value: hf_rent_total, label: '주택임차차입금 원리금상환액' },
    { value: hf_loan_total, label: '장기주택저당차입금 이자상환액' },
    { value: resultSet.special_income_ded_sum || 0, label: '특별소득 공제계' },
    { value: resultSet.deducted_income_amt || 0, label: '차감소득금액' },
  ];

  // 그 밖의 소득공제
  const home_saving_total =
    (resultSet.hf_saving1_ded || 0) +
    (resultSet.hf_saving2_ded || 0) +
    (resultSet.hf_saving4_ded || 0);
  const etc_arr = [
    { value: resultSet.ipen_saving_ded || 0, label: '개인연금저축' },
    { value: home_saving_total, label: '주택마련저축' },
    { value: resultSet.card_ded || 0, label: '신용카드등 사용금액' },
    { value: resultSet.etc_sbiz_ded || 0, label: '소기업 소상공인 공제부금 소득공제' },
    { value: resultSet.etc_invest_ded || 0, label: '투자조합 출자공제' },
    { value: resultSet.etc_esop_ded || 0, label: '우리사주출연금 소득공제' },
    { value: resultSet.etc_sme_emp_ded || 0, label: '고용유지 중소기업 근로자 소득공제' },
    { value: resultSet.etc_longinvest_ded || 0, label: '장기집합투자증권저축' },
    { value: resultSet.etc_longinvest_youth_ded || 0, label: '청년형 장기집합 투자증권저축' },
  ];

  // 세액감면
  const tax_reduction_arr = [
    { value: resultSet.tred_00_amt || 0, label: '소득세법 감면' },
    { value: resultSet.tred_01_amt || 0, label: '조특법(조세조약 제외) 감면' },
    { value: resultSet.tred_10_amt || 0, label: '조특법 제30조 감면' },
    { value: resultSet.tred_20_amt || 0, label: '조세조약 감면' },
  ];

  // 세액공제
  const pension_tax_arr = [
    { value: resultSet.tpen_scitech_ded || 0, label: '연금계좌 과학기술인' },
    { value: resultSet.tpen_retire_ded || 0, label: '연금계좌 퇴직연금' },
    { value: resultSet.tpen_saving_ded || 0, label: '연금계좌 연금저축' },
    { value: resultSet.tpen_isa_ded || 0, label: '연금계좌 ISA' },
  ];
  const pension_tax_sum = pension_tax_arr.reduce((sum, item) => sum + item.value, 0);

  const special_tax_arr = [
    { value: resultSet.insur_general_ded || 0, label: '보장성보험료' },
    { value: resultSet.insur_disabled_ded || 0, label: '장애인전용 보장성보험료' },
    { value: resultSet.medical_ded || 0, label: '의료비' },
    { value: resultSet.education_ded || 0, label: '교육비' },
    { value: resultSet.donation_20_u10_ded || 0, label: '정치자금기부금(10만원 이하)' },
    { value: resultSet.donation_20_o10_ded || 0, label: '정치자금기부금(10만원 초과)' },
    { value: resultSet.donation_43_u10_ded || 0, label: '고향사랑기부금(10만원 이하)' },
    { value: resultSet.donation_43_o10_ded || 0, label: '고향사랑기부금(10만원 초과)' },
    { value: resultSet.donation_10_ded || 0, label: '특례기부금' },
    { value: resultSet.donation_42_ded || 0, label: '우리사주조합기부금' },
    { value: resultSet.donation_40_ded || 0, label: '일반기부금(종교단체외)' },
    { value: resultSet.donation_41_ded || 0, label: '일반기부금(종교단체)' },
  ];

  const etc_tax_arr = [
    { value: resultSet.hf_loan_b_ded || 0, label: '주택차입금 세액공제' },
    { value: resultSet.tax_union_ded || 0, label: '납세조합공제' },
    { value: resultSet.hf_rent_m_ded || 0, label: '월세 세액공제' },
    { value: resultSet.foreign_tax_ded || 0, label: '외국납부 세액공제' },
  ];
  const etc_tax_sum = etc_tax_arr.reduce((sum, item) => sum + item.value, 0);

  const tax_ded_arr = [
    { value: resultSet.earned_income_tax_ded || 0, label: '근로소득세액공제' },
    { value: resultSet.t_ded_child || 0, label: '자녀(기본)' },
    { value: resultSet.t_ded_born_adopt || 0, label: '출산입양' },
    { value: resultSet.t_ded_marriage || 0, label: '결혼세액공제' },
    // { value: pension_tax_sum, label: '연금계좌세액공제', children: pension_tax_arr },
    { value: pension_tax_sum, label: '연금계좌세액공제' },
    { value: resultSet.tpen_scitech_ded || 0, label: '연금계좌 과학기술인', lv: 'dep2' },
    { value: resultSet.tpen_retire_ded || 0, label: '연금계좌 퇴직연금', lv: 'dep2' },
    { value: resultSet.tpen_saving_ded || 0, label: '연금계좌 연금저축', lv: 'dep2' },
    { value: resultSet.tpen_isa_ded || 0, label: '연금계좌 ISA', lv: 'dep2 _last' },
    //
    // { value: resultSet.special_tax_ded_sum || 0, label: '특별세액공제', children: special_tax_arr },
    { value: resultSet.special_tax_ded_sum || 0, label: '특별세액공제' },
    { value: resultSet.insur_general_ded || 0, label: '보장성보험료', lv: 'dep2' },
    { value: resultSet.insur_disabled_ded || 0, label: '장애인전용 보장성보험료', lv: 'dep2' },
    { value: resultSet.medical_ded || 0, label: '의료비', lv: 'dep2' },
    { value: resultSet.education_ded || 0, label: '교육비', lv: 'dep2' },
    { value: resultSet.donation_20_u10_ded || 0, label: '정치자금기부금(10만원 이하)', lv: 'dep2' },
    { value: resultSet.donation_20_o10_ded || 0, label: '정치자금기부금(10만원 초과)', lv: 'dep2' },
    { value: resultSet.donation_43_u10_ded || 0, label: '고향사랑기부금(10만원 이하)', lv: 'dep2' },
    { value: resultSet.donation_43_o10_ded || 0, label: '고향사랑기부금(10만원 초과)', lv: 'dep2' },
    { value: resultSet.donation_10_ded || 0, label: '특례기부금', lv: 'dep2' },
    { value: resultSet.donation_42_ded || 0, label: '우리사주조합기부금', lv: 'dep2' },
    { value: resultSet.donation_40_ded || 0, label: '일반기부금(종교단체외)', lv: 'dep2' },
    { value: resultSet.donation_41_ded || 0, label: '일반기부금(종교단체)', lv: 'dep2 _last' },
    //
    { value: resultSet.standard_tax_ded || 0, label: '표준세액공제' },
    // { value: etc_tax_sum, label: '기타세액공제', children: etc_tax_arr },
    { value: etc_tax_sum, label: '기타세액공제' },
    { value: resultSet.hf_loan_b_ded || 0, label: '주택차입금 세액공제', lv: 'dep2' },
    { value: resultSet.tax_union_ded || 0, label: '납세조합공제', lv: 'dep2' },
    { value: resultSet.hf_rent_m_ded || 0, label: '월세 세액공제', lv: 'dep2' },
    { value: resultSet.foreign_tax_ded || 0, label: '외국납부 세액공제', lv: 'dep2 _last' },
    //
  ];

  // 결정세액 계
  const determined_tax_arr = [
    { value: resultSet.final_tax || 0, label: '결정세액 소득세' },
    { value: resultSet.final_tax_local || 0, label: '결정세액 지방소득세' },
    { value: resultSet.final_tax_rural || 0, label: '결정세액 농특세' },
  ];
  const determined_tax_sum = determined_tax_arr.reduce((sum, item) => sum + item.value, 0);

  // 기납세액 계
  const prepaid_tax_arr = [
    { value: resultSet.prepaid_tax || 0, label: '기납부세액 소득세' },
    { value: resultSet.prepaid_tax_local || 0, label: '기납부세액 지방소득세' },
    { value: resultSet.prepaid_tax_rural || 0, label: '기납부세액 농특세' },
  ];
  const prepaid_tax_sum = prepaid_tax_arr.reduce((sum, item) => sum + item.value, 0);

  // 환급 또는 추가납부 세액 계
  const withheld_tax_arr = [
    { value: resultSet.withheld_tax || 0, label: '차감징수세액 소득세' },
    { value: resultSet.withheld_tax_local || 0, label: '차감징수세액 지방소득세' },
    { value: resultSet.withheld_tax_rural || 0, label: '차감징수세액 농특세' },
  ];
  const withheld_tax_sum = withheld_tax_arr.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="_income_detail_set">
      <div className="_content_div">
        {/* // 소득정산 내역 */}
        <section className="_section">
          <div className="_title_div">
            <div className="_title">소득정산 내역</div>
            <div className="_desc">세율을 적용할 소득(과세표준)을 확정하는 계산 과정입니다.</div>
          </div>

          <div className="_content">
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="총급여"
                value={addComma(resultSet.gross_salary)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                styleDef={{ marginBottom: '15px' }}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="소득명세"
                value={addComma(resultSet.earned_income_amt || 0)}
                content={<DeductionDiv type={type} data={income_detail_arr} />}
                foldViewType="type2"
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="인적 공제"
                value={addComma(personal_deduction_sum)}
                content={<DeductionDiv type={type} data={personal_deduction_arr} />}
                foldViewType="type2"
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="연금보험료 공제"
                value={addComma(pension_insurance_sum)}
                content={<DeductionDiv type={type} data={pension_insurance_arr} />}
                foldViewType="type2"
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="특별소득 공제"
                value={addComma(resultSet.special_income_ded_sum || 0)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={special_income_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="그 밖의 소득공제"
                value={addComma(resultSet.etc_ded_sum || 0)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={etc_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="소득공제 종합한도 초과액"
                value={addComma(resultSet.income_ded_limit_excess || 0)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500' }}
              />
            </div>
            <div className="_item ">
              <TitleContentDetail
                id="taxation"
                label="과세표준"
                value={addComma(resultSet.income_tax_base || 0)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                styleDef={{ marginTop: '5px', borderTop: '1px solid #ddd', paddingTop: '15px' }}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
          </div>
        </section>

        {/* // 세액 산출 내역 */}
        <section className="_section">
          <div className="_title_div">
            <div className="_title">세액 산출 내역</div>
            <div className="_desc">
              과세표준 급여를 바탕으로 세액구간별 산출 세액을 계산하는 과정입니다.
            </div>
          </div>
          <div className="_content">
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="과세표준"
                value={addComma(resultSet.income_tax_base || 0)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="산출세액"
                value={addComma(resultSet.tax_cal_amt || 0)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                styleDef={{ marginTop: '5px', borderTop: '1px solid #ddd', paddingTop: '15px' }}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
          </div>
        </section>

        {/* // 세액 정산 내역 */}
        <section className="_section">
          <div className="_title_div">
            <div className="_title">세액 정산 내역</div>
            <div className="_desc">
              세액을 적용한 후의 최종세액(결정세액)을 계산하는 과정입니다.
            </div>
          </div>
          <div className="_content">
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="산출세액"
                value={addComma(resultSet.tax_cal_amt || 0)}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="세액 감면"
                value={addComma(resultSet.tred_sum || 0)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={tax_reduction_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="세액 공제"
                value={addComma(resultSet.tax_ded_sum || 0)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={tax_ded_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="결정세액 계"
                value={addComma(determined_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={determined_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '13px', fontWeight: '500', width: '120px' }}
              />
            </div>
            <div className="_item _line" style={{ borderBottom: '0px solid #ddd' }}>
              <TitleContentDetail
                id="taxation"
                label="기납세액 계"
                value={addComma(prepaid_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={prepaid_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{
                  fontSize: '13px',
                  fontWeight: '500',
                  width: '120px',
                }}
              />
            </div>
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="환급 또는 추가납부 세액 계"
                value={addComma(withheld_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={withheld_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                styleDef={{ marginTop: '5px', borderTop: '1px solid #ddd', paddingTop: '15px' }}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500', width: '180px' }}
              />
            </div>
          </div>
        </section>

        {/* 최종세액 안내 */}
        <section className="_section">
          <div className="_title_div">
            <div className="_title">최종 세액 안내</div>
            <div className="_desc">
              모든 항목의 세액을 통합하여 최종 납부/환급 세액을 산출하는 과정입니다.
            </div>
          </div>
          <div className="_content">
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="결정세액 계"
                value={addComma(determined_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={determined_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500', width: '180px' }}
              />
            </div>
            <div className="_item _line">
              <TitleContentDetail
                id="taxation"
                label="기납세액 계"
                value={addComma(prepaid_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={prepaid_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500', width: '180px' }}
              />
            </div>
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="환급 또는 추가납부 세액 계"
                value={addComma(withheld_tax_sum)}
                foldViewType="type2"
                content={<DeductionDiv type={type} data={withheld_tax_arr} />}
                foldBtn={true}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500', width: '180px' }}
              />
            </div>
            <div className="_item">
              <TitleContentDetail
                id="taxation"
                label="최종 납부/환급 세액"
                valueContent={refundDiv}
                content={<></>}
                foldBtn={false}
                foldBtnClickEvent={foldClickEvent}
                contentView={false}
                styleDef={{
                  marginTop: '5px',
                  borderTop: '1px solid #ddd',
                  paddingTop: '20px',
                  fontSize: '20px',
                }}
                labelStyleDef={{ fontSize: '14px', fontWeight: '500' }}
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GridList;
